import styled from 'styled-components'

export const SupplyCountryFilterWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
`
